import { PlusOutlined } from '@ant-design/icons'
import { Col, Row, List, Button } from 'antd'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import { UtenteModel } from '../../models/UtenteModels'

import { TTAvatarName } from '../shared/TTAvatarName'
import { ClienteParams } from './ClienteParams'

interface TabUtentiProps {
    utenti: Array<UtenteModel>
    clienteId: string
}

class TabUtentiComp extends React.Component<RouteComponentProps<ClienteParams> & TabUtentiProps, any> {
    constructor(props) {
        super(props)
    }

    onUtenteClick = id => {
        this.props.history.push(`/UtenteCliente/Modifica/${this.props.clienteId}/${id}`)
    }

    onUtenteAddClick = () => {
        this.props.history.push(`/UtenteCliente/Modifica/${this.props.clienteId}`)
    }

    render() {

        let listaUtenti = this.props.utenti != null
            ?<List
                dataSource={this.props.utenti}
                rowKey={it => it.Id}
                renderItem={item => (
                    <List.Item key={item.Id}>
                        <List.Item.Meta
                            avatar={<TTAvatarName size="large" nome={item.Nominativo} />}
                            title={<a onClick={() => this.onUtenteClick(item.Id)}>{`${item.Nominativo}`}</a>}
                        />
                    </List.Item>
                )}
            />
            : <></>

        return (
            <>
                <Row justify="end">
                    <Col>
                        <Button type="primary" key="add-user" icon={<PlusOutlined />} onClick={() => this.onUtenteAddClick()}>Aggiungi</Button>
                    </Col>
                </Row>
                {listaUtenti}
            </>
        )
    }
}

export const TabUtenti = withRouter(TabUtentiComp)